export const currencies = [
    {
      id: 1,
      name: "United States dollar",
      namePL: "Dolar amerykański",
      code: "USD",
      symbol: "$",
      rate: 3.6491,
    },
    {
      id: 2,
      name: "Euro",
      namePL: "Euro",
      code: "EUR",
      symbol: "€",
      rate: 4.2274,
    },
    {
      id: 3,
      name: "Pound sterling",
      namePL: "Brytyjski funt szterling",
      code: "GBP",
      symbol: "£",
      rate: 4.8189,
    },
    {
      id: 4,
      name: "Bitcoin",
      namePL: "Bitcoin",
      code: "BTC",
      symbol: "₿",
      rate: 320727.6,
    },
  ];